// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.None-root-13bd{position:relative;width:100vw;height:100dvh}.None-preload-13bd{position:absolute;inset:0;overflow:hidden;opacity:0}`, "",{"version":3,"sources":["webpack://./src/page/None/None.module.scss"],"names":[],"mappings":"AAAA,gBACE,iBAAA,CACA,WAAA,CACA,aAAA,CAGF,mBACE,iBAAA,CACA,OAAA,CACA,eAAA,CACA,SAAA","sourcesContent":[".root {\n  position: relative;\n  width: 100vw;\n  height: 100dvh;\n}\n\n.preload {\n  position: absolute;\n  inset: 0;\n  overflow: hidden;\n  opacity: 0;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `None-root-13bd`,
	"preload": `None-preload-13bd`
};
module.exports = ___CSS_LOADER_EXPORT___;
